const isSet = (value: unknown): boolean => value !== null && value !== undefined && value !== '';

// io.order stores an all-null PriceData for orders without a Grenzpreis and rejects it if sent.
// Only the fields its validation requires make a Grenzpreis real.
export const hasMarginalPrice = (price?: Record<string, any> | null): boolean => !!price
  && isSet(price.workingPrice)
  && isSet(price.usageFrom)
  && isSet(price.usageTo);

export default hasMarginalPrice;
